var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-calendar',{attrs:{"events":_vm.events},on:{"day_click":function($event){return _vm.check($event)},"event_selected":function($event){return _vm.check($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }